import { BRAND_INFO } from '../actions';


export default function(state = {}, action) {
  switch (action.type) {
  case BRAND_INFO:
    return {...state, name: action.payload.name, website: action.payload.website};
  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_brand_info.js